import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PatrolDiscordCockpitService } from '../../../services/patrol-discord-cockpit.service';

@Component({
  selector: 'app-patrol-discord-mod-queue',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './patrol-discord-mod-queue.component.html',
  styleUrl: './patrol-discord-mod-queue.component.scss',
})
export class PatrolDiscordModQueueComponent {
  #cockpit = inject(PatrolDiscordCockpitService);

  readonly modQueueItems = this.#cockpit.modQueueItems;
  readonly isLoading = this.#cockpit.isLoadingModQueue;
  readonly loadError = this.#cockpit.modQueueError;
  readonly actionId = this.#cockpit.modQueueActionId;

  formatDate(iso: string): string {
    return this.#cockpit.formatDate(iso);
  }

  isBusy(id: string): boolean {
    return this.actionId() === id;
  }

  approve(id: string): void {
    void this.#cockpit.approveModQueueItem(id);
  }

  reject(id: string): void {
    void this.#cockpit.rejectModQueueItem(id);
  }
}
